/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Email Notification type
 */
export enum EmailNotificationTypeDTO {
    PASSWORD_CHANGED = 'PASSWORD_CHANGED',
    PERMISSION_CHANGED = 'PERMISSION_CHANGED',
    USER_DEACTIVATED = 'USER_DEACTIVATED',
    FCC_INITIALIZED = 'FCC_INITIALIZED',
    FCC_DEACTIVATED = 'FCC_DEACTIVATED',
    KEY_READY = 'KEY_READY',
    NEW_CLIENT_REGISTERED = 'NEW_CLIENT_REGISTERED',
    NEW_LOGS_AVAILABLE = 'NEW_LOGS_AVAILABLE',
    USER_CREATED = 'USER_CREATED',
    ARCHIVE_IMPORT_CREATED = 'ARCHIVE_IMPORT_CREATED',
    ARCHIVE_IMPORT_DELETED = 'ARCHIVE_IMPORT_DELETED',
    ARCHIVE_PROCEDURAL_DOCUMENTATION_DELETED = 'ARCHIVE_PROCEDURAL_DOCUMENTATION_DELETED',
    ARCHIVE_EXPORT_CREATED = 'ARCHIVE_EXPORT_CREATED',
    ARCHIVE_EXPORT_EXTENDED = 'ARCHIVE_EXPORT_EXTENDED',
    ARCHIVE_EXPORT_DELETED = 'ARCHIVE_EXPORT_DELETED',
    ARCHIVE_UPLOAD_POOL_EXHAUSTED = 'ARCHIVE_UPLOAD_POOL_EXHAUSTED',
    ARCHIVE_DOWNLOAD_POOL_EXHAUSTED = 'ARCHIVE_DOWNLOAD_POOL_EXHAUSTED',
    STATISTICS_REPORT = 'STATISTICS_REPORT',
    TSS_LOGS_EXPIRE = 'TSS_LOGS_EXPIRE',
    USER_DELETED = 'USER_DELETED',
    CONTRACT_VOLUME_EXHAUSTED = 'CONTRACT_VOLUME_EXHAUSTED',
    TSS_LOGS_REMOVED = 'TSS_LOGS_REMOVED',
    DATA_RETENTION_EXPIRE = 'DATA_RETENTION_EXPIRE',
    DATA_RETENTION_DECISION = 'DATA_RETENTION_DECISION',
    FCC_DEACTIVATED_NEED_MANUAL_EXPORT = 'FCC_DEACTIVATED_NEED_MANUAL_EXPORT',
    ARCHIVE_OFFBOARDING = 'ARCHIVE_OFFBOARDING',
    ARCHIVE_OFFBOARDING_REMINDER = 'ARCHIVE_OFFBOARDING_REMINDER',
    ARCHIVE_OFFBOARDING_DOWNLOADED = 'ARCHIVE_OFFBOARDING_DOWNLOADED'
}

export class ClsEmailNotificationTypeDTO {
    PASSWORD_CHANGED = 'PASSWORD_CHANGED';
    PERMISSION_CHANGED = 'PERMISSION_CHANGED';
    USER_DEACTIVATED = 'USER_DEACTIVATED';
    FCC_INITIALIZED = 'FCC_INITIALIZED';
    FCC_DEACTIVATED = 'FCC_DEACTIVATED';
    KEY_READY = 'KEY_READY';
    NEW_CLIENT_REGISTERED = 'NEW_CLIENT_REGISTERED';
    NEW_LOGS_AVAILABLE = 'NEW_LOGS_AVAILABLE';
    USER_CREATED = 'USER_CREATED';
    ARCHIVE_IMPORT_CREATED = 'ARCHIVE_IMPORT_CREATED';
    ARCHIVE_IMPORT_DELETED = 'ARCHIVE_IMPORT_DELETED';
    ARCHIVE_PROCEDURAL_DOCUMENTATION_DELETED = 'ARCHIVE_PROCEDURAL_DOCUMENTATION_DELETED';
    ARCHIVE_EXPORT_CREATED = 'ARCHIVE_EXPORT_CREATED';
    ARCHIVE_EXPORT_EXTENDED = 'ARCHIVE_EXPORT_EXTENDED';
    ARCHIVE_EXPORT_DELETED = 'ARCHIVE_EXPORT_DELETED';
    ARCHIVE_UPLOAD_POOL_EXHAUSTED = 'ARCHIVE_UPLOAD_POOL_EXHAUSTED';
    ARCHIVE_DOWNLOAD_POOL_EXHAUSTED = 'ARCHIVE_DOWNLOAD_POOL_EXHAUSTED';
    STATISTICS_REPORT = 'STATISTICS_REPORT';
    TSS_LOGS_EXPIRE = 'TSS_LOGS_EXPIRE';
    USER_DELETED = 'USER_DELETED';
    CONTRACT_VOLUME_EXHAUSTED = 'CONTRACT_VOLUME_EXHAUSTED';
    TSS_LOGS_REMOVED = 'TSS_LOGS_REMOVED';
    DATA_RETENTION_EXPIRE = 'DATA_RETENTION_EXPIRE';
    DATA_RETENTION_DECISION = 'DATA_RETENTION_DECISION';
    FCC_DEACTIVATED_NEED_MANUAL_EXPORT = 'FCC_DEACTIVATED_NEED_MANUAL_EXPORT';
    ARCHIVE_OFFBOARDING = 'ARCHIVE_OFFBOARDING';
    ARCHIVE_OFFBOARDING_REMINDER = 'ARCHIVE_OFFBOARDING_REMINDER';
    ARCHIVE_OFFBOARDING_DOWNLOADED = 'ARCHIVE_OFFBOARDING_DOWNLOADED';
}

